import Link from "next/link";
import React, { useState } from "react";
import { Container, Nav } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useRouter } from "next/router";
import Logo from "../../../svg/logo.svg";
import nookies from "nookies";
import Image from "next/future/image";
import PhoneIcon from "./assets/phone.svg";

const HeaderBottom = ({
  handleMobileSideBarActivation,
  data,
  servicesData,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { locale, push, pathname, asPath } = useRouter();

  const changeLanguage = (event, language) => {
    event.preventDefault();
    nookies.set(null, "locale", language, { path: "/" });
    push(pathname, asPath, { locale: language });
  };
const isRtl = locale === "ar";

  const isActive = (path) => (pathname === path ? "active" : "");

  return (
    <Container className="header-bottom-container">
      <Nav className="header-bottom">
        <div className="d-lg-none burger-icon-languages">
          <svg
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="burgerIcon"
            onClick={handleMobileSideBarActivation}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
          <div className="language">
            <button
              onClick={(e) => changeLanguage(e, locale === "ar" ? "en" : "ar")}
              href="/"
            >
              {locale === "ar" ? "en" : "العربية"}
            </button>
          </div>
        </div>

        <div className="logo-section">
          <Link href="/">
            <a>
              <div className="logo">
                {data?.AppSetting?.appLogo ? (
                  <Image
                    src={`${process.env.NEXT_PUBLIC_API_URL}/${data?.AppSetting?.appLogo}`}
                    alt="logo"
                    width={1920}
                    height={1080}
                    priority={true}
                  />
                ) : (
                  <Logo />
                )}
              </div>
            </a>
          </Link>
        </div>

        <div className="links-section">
          <Link href="/">
            <a className={`${isActive("/")} custom-link`}>
              <FormattedMessage id="home" />
            </a>
          </Link>

          <Link href="/aboutus">
            <a className={`${isActive("/aboutus")} custom-link`}>
              <FormattedMessage id="about" />
            </a>
          </Link>

          {/* <div
            className="mega-menu-wrapper"
            onMouseEnter={() => setIsMenuOpen(true)}
            onMouseLeave={() => setIsMenuOpen(false)}
          > */}
            <Link href="/services">
              <a
                className={`${isActive("/services")} custom-link `} /*mega-menu-button*/
              >
                <FormattedMessage id="services" />
              </a>
            </Link>
            {/* <div
              className={`mega-menu ${isMenuOpen ? "active" : ""}`}
              dir={locale === "ar" ? "rtl" : "ltr"}
            >
              <Container>
                <Row className="gy-3">
                  {servicesData?.slice(0, 4).map((item, index) => (
                    <Col md={6} key={index}>
                      <div
                        className="mega-menu-item"
                        dir={locale === "ar" ? "rtl" : "ltr"}
                      >
                        <Link href={`/services/${item?.slug}`}>
                          <a className="mega-menu-link">
                            <div className="img">
                              {item?.image && (
                                <Image
                                  src={`${process.env.NEXT_PUBLIC_API_URL}/${item.image}`}
                                  alt={item?.title?.[locale] || "service"}
                                  width={100}
                                  height={100}
                                />
                              )}
                            </div>
                            {item?.title?.[locale] && (
                              <span className="title">
                                {item.title[locale].length > 24
                                  ? `${item.title[locale].slice(0, 24)}...`
                                  : item.title[locale]}
                              </span>
                            )}
                          </a>
                        </Link>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Container>
            </div> */}
          {/* </div> */}

          <Link href="/ourworks">
            <a className={`${isActive("/ourworks")} custom-link`}>
              <FormattedMessage id="our-works" />
            </a>
          </Link>

          <Link href="/blogs">
            <a className={`${isActive("/blogs")} custom-link`}>
              <FormattedMessage id="blogs" />
            </a>
          </Link>
        </div>

        <div className="contact-lang-section">
          <Link href="/contactus">
            <a className={`${isActive("/contactus")} custom-link contactus`}>
              <FormattedMessage id="contact-us" />
                <div 
                style={{
              width: "40px",
              height: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
                  background: "linear-gradient(90deg, #E90000 0%, #830000 100%)",
                  borderRadius:"500px",

            }}
                >
                
                <svg
            style={{ transform: isRtl ? "none" : "scaleX(-1)" }}
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.53577 3.53556L14.1424 14.1422"
                  stroke="white"
                  strokeWidth={1.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                  stroke="white"
                  strokeWidth={1.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
                </div>

            </a>
          </Link>

          <button
            className="custom-link desktop-language"
            onClick={(e) => changeLanguage(e, locale === "ar" ? "en" : "ar")}
          >
            {locale === "ar" ? "en" : "العربية"}
          </button>
        </div>

        <div className="phone-booking">
          <div className="phone-icon">
            <Link href={`tel:${data?.socials?.phone}`}>
              <a aria-label="phone">
                <PhoneIcon />
              </a>
            </Link>
          </div>
        </div>
      </Nav>
    </Container>
  );
};

export default HeaderBottom;
